import React, {PureComponent} from 'react';
import {Storage} from '@stubhub/legacy-cache';
import DocumentUtil from './documentUtil';
import uuid from '@stubhub/visitor-id';

class Simility extends PureComponent {
  async componentDidMount() /* istanbul ignore next: client side code */{
    if (typeof window !== 'undefined') {
      if (!window.SimilityScript) {
        await DocumentUtil.insertScript('simility-recon', '//cdn.simility.com/b.js');
      }

      const sessionId = _triggerFeLogin();
      if (process.env.REACT_APP_SIMILITY_FE_TRANSACTION === '1') {
        _triggerFeTransaction(sessionId);
      }
    }
  }

  render() {
    return (
      <div id='simility_container'>
      </div>
    );
  }
}

function _triggerFeTransaction(sessionId) {
  const checkoutSessionId = uuid();
  const similityScriptContext = buildSimilityScriptContext('fe_transaction', sessionId, checkoutSessionId, 'SH_SMREFID_TRANSACTION');
  new window.SimilityScript(similityScriptContext).execute();
  return checkoutSessionId;
}

function _triggerFeLogin() {
  let sessionId = Storage.getItem('SH_SMREFID', 'local');
  if (sessionId) {
    return sessionId;
  }
  sessionId = uuid();
  const similityScriptContext = buildSimilityScriptContext('fe_login', sessionId, sessionId, 'SH_SMREFID');
  new window.SimilityScript(similityScriptContext).execute();
  return sessionId;
}

function buildSimilityScriptContext(entityType, sessionId, id, cookieId) {
  return {
    "customer_id": process.env.REACT_APP_SIMILITY_ID,
    "simility_lite_level": 0,
    "session_id": sessionId,
    "transaction_info": [
      {
        "entity": entityType,
        "id": id
      }
    ],
    "status_callback": () => {
      Storage.setItem(cookieId, id, 'local', 24 * 60 * 60 * 1000);
    }
  };
}

export default Simility;
